<h1 mat-dialog-title>Nutzer Einladen</h1>
<div class="content-box" mat-dialog-content>
  <form>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Email</mat-label>
      <input [formControl]="email" type="email" value="" matInput>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button [disabled]="!email.valid" [mat-dialog-close]="email.value" mat-raised-button color="accent">Ok</button>
  <button style="margin-left: auto" [mat-dialog-close]="false" mat-raised-button>Abbrechen</button>
</div>



